import { OPEN_MODAL, CLOSE_MODAL } from "./constants"
import ModalWrapper from "./wrapper"

export const initialState = {
  modalIsOpen: false,
  modalContents: () => null,
  modalProps: {},
  hideCloseIcon: false,
  shouldCloseOnOverlayClick: true,
}

// eslint-disable-next-line default-param-last
export default (state = initialState, action) => {
  const newState = { ...state }
  switch (action.type) {
    case OPEN_MODAL:
      newState.modalContents = ModalWrapper(action.modalContents)
      newState.modalIsOpen = true
      newState.modalProps = action.modalProps
      newState.hideCloseIcon = action.hideCloseIcon
      newState.shouldCloseOnOverlayClick = action.shouldCloseOnOverlayClick
      break
    case CLOSE_MODAL:
      newState.modalIsOpen = false
      newState.modalContents = () => null
      newState.modalProps = {}
      newState.hideCloseIcon = false
      newState.shouldCloseOnOverlayClick = true
      break
    default:
      return state
  }
  return newState
}
